import {
  CitiesResponse,
  Id,
  LocationCreateResponse,
  LocationPayload,
  LocationResponse,
  LocationsResponse,
  Options,
  Resource
} from 'services/api';

import Company from './Company.service';

export default class Location extends Company {
  private static instance: Location;

  private constructor(options: Options) {
    /* istanbul ignore next */
    super(options);
    // this related to how typescript transpile this line in es5
    // e.g. var _this = _super.call(this) || this;
  }

  /**
   * This return the singleton instance of the class
   * @param {Options} options
   */
  public static getInstance(options: Options) {
    if (!this.instance) {
      this.instance = new this(options);
    }

    return this.instance;
  }

  /**
   * Get a list of company locations
   * @param {Id} [company_id] (optional) company id
   */
  list(params?: Record<string, any>, company_id?: Id) {
    return this.getEntities<LocationsResponse>(
      Resource.Locations,
      params,
      company_id
    );
  }

  /**
   * Get a location by id
   * @param {Id} id location id
   * @param {Id} [company_id] (optional) company id
   */
  get(id: Id, company_id?: Id) {
    return this.getEntity<LocationResponse>(Resource.Location, id, company_id);
  }

  /**
   * Create a location
   * @param {LocationPayload} payload
   * @param {string} payload.address_id
   * @param {string} payload.campus
   * @param {string} payload.delivery_instructions
   * @param {string} payload.floor
   * @param {LocationState} payload.state
   * @param {Id} company_id
   */
  create(payload: LocationPayload, company_id?: Id) {
    return this.createEntity<LocationCreateResponse, LocationPayload>(
      Resource.Location,
      payload,
      company_id
    );
  }

  /**
   * Delete a location by id
   * @param {Id} id location id
   * @param {Id} [company_id] (optional) company id
   */
  delete(id: Id, company_id?: Id) {
    return this.deleteEntity(Resource.Location, id, company_id);
  }

  /**
   * Update a location by id
   * @param {Id} id resource id
   * @param {LocationPayload} payload
   * @param {string} payload.address_id
   * @param {string} payload.campus
   * @param {string} payload.delivery_instructions
   * @param {string} payload.floor
   * @param {LocationState} payload.state
   * @param {Id} [company_id] (optional) company id
   */
  update(id: Id, payload: LocationPayload, company_id?: Id) {
    return this.updateEntity<LocationPayload>(
      Resource.Location,
      id,
      payload,
      company_id
    );
  }

  getCities() {
    const url = this.generateUrl('/company-portal/locations/cities');
    return this.makeRequest<CitiesResponse>({
      url,
      method: this._request.Get
    });
  }
}
